<template>
	<v-overlay
		:opacity="0.2"
		:value="true"
		z-index="9"
		@click="closeObservations"
	>
		<v-card
			class="card-comment-container"
			light
			color="white"
			width="400"
			:style="{
				position: 'fixed',
				top: `${commentPosition.top}px`,
				left: `${commentPosition.left}px`
			}"
			@click.stop
			:ripple="false"
			>
			<v-card-text class="pa-0" style="background: white;width:400px;">
				<div class="py-1 px-4" style="background: #959595;">
					<p class="caption mb-0 font-weight-bold white--text">Observaciones en Sección</p>
				</div>
				<v-list dense class="py-0" max-height="300" style="overflow-y: auto;" ref="scrollListComment">
					<v-list-item-group color="#524D4D" v-if="section_content.observation">
						<v-list-item
							v-for="(comment, index) in sectionComments"
							:key="'comments-' + index"
							dense
						>
							<v-list-item-title dense>
								<div class="d-flex justify-space-between item-background-hover py-2">
									<div class="d-flex">
										<v-icon :color="comment.side == 1 ? 'warning':''">mdi-comment-plus-outline</v-icon>
										<div class="ml-2">
											<div class="font-weight-bold caption">{{ comment.user.profile.name }} {{ comment.user.profile.lastname }} {{ comment.user.profile.second_lastname }} <small>({{ comment.side == 1 ? 'Cliente':'Empresa' }})</small></div>
											<div class="caption">{{ comment.comment }}</div>
										</div>
									</div>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												fab
												dark
												x-small
												icon
												color="error"
												@click="deleteComment(comment)"
												v-bind="attrs"
												v-on="on"
												v-if="userInfo && userInfo.id == comment.user_id && !disableNewObservations"
											>
												<v-icon small dark>mdi-delete-outline</v-icon>
											</v-btn>
										</template>
										<span>Eliminar Comentario</span>
									</v-tooltip>
								</div>
							</v-list-item-title>
						</v-list-item>
					</v-list-item-group>
				</v-list>
				<v-divider class="my-2" v-if="!disableNewObservations"></v-divider>
				<div class="px-4 pb-4" v-if="!disableNewObservations">
					<v-text-field
						label="Ingrese Comentario"
						v-model="sectionComment"
						class="custom-height-search custom-height-calendar mb-2"
						hide-details
						dense
						outlined
						validate-on-blur
						:rules="requiredRule"
						@keyup.enter="saveComment"
					></v-text-field>
					<div class="my-1 d-flex justify-center align-center" v-if="side == 2">
						<v-checkbox v-model="sectionCommentResolution" :disabled="!sectionComment" class="my-0 pt-0" color="green" label="Marcar Como Resuelto" hide-details dense></v-checkbox>
					</div>
					<v-btn
						depressed
						color="green"
						:dark="!!sectionComment"
						small
						block
						:disabled="!sectionComment"
						:loading="loadingComment"
						@click="saveComment"
					>
						<v-icon small>mdi-check</v-icon>
						<p class="mb-0 ml-2 caption">Confirmar</p>
					</v-btn>
					<v-btn
						depressed
						color="#959595"
						text
						x-small
						block
						class="mt-2"
						@click="closeObservations"
					>
						<p class="mb-0">Cerrar</p>
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</v-overlay>
</template>

<script>
import {  deleteContractContentComment, createContractContentComment } from '@/helpers/api/contracts'
import contractStatuses from '@/components/Helpers/Constants/contract'
export default {
	name: 'ObservationOverlay',
	props: {
		contract: {
			type: Object,
			required: true
		},
		commentPosition: {
			type: Object,
			required: true
		},
		section_content: {
			type: Object,
			required: true
		},
		side: {
			type: Number,
			required: true
		},
	},
	data() {
		return {
			contractStatuses,
			localContract: null,
			loadingComment: false,
			sectionComment: null,
			sectionCommentResolution: false,
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
		}
	},
	computed: {
		disableNewObservations(){
			return this.contract?.last_status?.status >= contractStatuses.ACEPTADO
		},
		userInfo(){
			return this.$store.state.user.userInfo
		},
		sectionComments(){
			for (const section of this.localContract.sections) {
				for (const content of section.contents) {
					if (content.id == this.section_content.id && content.observation) {
						if (!Array.isArray(content.observation.comments)) {
							this.$set(content.observation, 'comments', []);
						}
						return content.observation.comments
					}
				}
			}
			return []
		},
	},
	watch: {
		contract: {
			immediate: true,
			deep: true,
			handler(val) {
				this.localContract = JSON.parse(JSON.stringify(val))
			}
		}
	},
	mounted() {
		this.scrollToBottom()
	},
	methods: {
		scrollToBottom(retries = 10) {
			this.$nextTick(() => {
				const container = this.$refs.scrollListComment.$el
				if (container) {
					container.scrollTop = container.scrollHeight
				} else if (retries > 0) {
					setTimeout(() => this.scrollToBottom(retries - 1), 50)
				}
			})
		},
		closeObservations() {
			this.$emit('closeObservationOverlay');
			this.sectionComment = null
			this.sectionCommentResolution = false
		},
		async deleteComment(comment){
			await deleteContractContentComment({contract_content_comment_id: comment.id})
			this.getContractInfo()
			this.sectionComment = null
			this.sectionCommentResolution = false
		},
		async saveComment(){
			if(!this.sectionComment || this.sectionComment.length == 0 || this.sectionComment == '') return
			this.loadingComment = true
			const data = {
				contract_id: this.localContract.id,
				contract_content_id: this.section_content.id,
				comment: this.sectionComment,
				resolved: this.sectionCommentResolution,
				side: this.side
			}
			this.setNewCommentBeforeInsert(data)
			this.sectionComment = null
			this.sectionCommentResolution = false
			await createContractContentComment(data)
			this.$emit('reloadInformation')
			this.loadingComment = false
		},
		setNewCommentBeforeInsert(data) {
			for (const section of this.localContract.sections) {
				for (const content of section.contents) {
					if (content.id === data.contract_content_id) {

						if (!content.observation) {
							this.$set(content, 'observation', {
								contract_content_id: data.contract_content_id,
								comments: []
							})
						}

						if (!Array.isArray(content.observation.comments)) {
							this.$set(content.observation, 'comments', [])
						}

						content.observation.comments.push({
							user: this.userInfo,
							comment: data.comment,
							side: data.side
						})
					}
				}
			}
			
			this.scrollToBottom()
		},
	}
}
</script>

<style>

</style>